import { makeAutoObservable } from 'mobx';
import { AxiosResponse, isAxiosError } from 'axios';
import AuthStore from '../features/auth/store/auth.store';
import { requestService, RequestService } from '../services/api.service';
import navigationStore, { NavigationStore } from './navigation.store';
import UserStore from '../features/user/store/user.store';
import GameStore from '../features/games/store/game.store';
import notificationStore, { NotificationStore } from './notificationStore';
import ConsoleStore from '../features/console/store/console.store';

export class RootStore {
  public user: UserStore;
  public auth: AuthStore;
  public game: GameStore;
  public console: ConsoleStore;
  public navigation: NavigationStore;
  public notifications: NotificationStore;

  public requestError: string | undefined;
  public loading = false;
  public requestSuccess: boolean | undefined;

  constructor() {
    this.game = new GameStore(this);
    this.user = new UserStore(this);
    this.auth = new AuthStore(this);
    this.console = new ConsoleStore(this);
    this.navigation = navigationStore;
    this.notifications = notificationStore;

    makeAutoObservable(this);

    this.game.afterCreate?.();
    this.user.afterCreate?.();
  }

  public dispose() {
    this.requestError = undefined;
    this.loading = false;
    this.requestSuccess = undefined;
    this.auth.dispose();
  }

  public async request({
    route,
    method,
    params,
    succesCode = 200,
    success,
    errorMessage = 'Ошибка запроса',
  }: {
    method: keyof RequestService;
    route: string;
    params?: any;
    succesCode?: number;
    success?: (res: AxiosResponse<any, any>) => any;
    errorMessage?: string;
  }) {
    this.loading = true;
    this.requestError = undefined;
    this.requestSuccess = undefined;
    try {
      const response = await requestService[method](route, params);
      if (response.status === succesCode) {
        success?.(response);
        this.requestSuccess = true;
      }
    } catch (e) {
      this.requestSuccess = false;
      if (e instanceof Error && isAxiosError(e) && e.response) {
        this.requestError = e.response.data.message || errorMessage;
      } else {
        this.requestError = errorMessage;
      }
    } finally {
      this.loading = false;
    }
  }
}

const store = new RootStore();
export default store;
